const METRIKA_ID = 109966509;

// Идентификатор JS-цели в Метрике. В интерфейсе цель называется «отправка формы».
export const FORM_SUBMIT_GOAL = 'form_submit';

export function reachFormSubmitGoal() {
    if (typeof window === 'undefined' || typeof window.ym !== 'function') {
        return;
    }
    window.ym(METRIKA_ID, 'reachGoal', FORM_SUBMIT_GOAL);
}

export function loadYandexMetrika() {
    if (typeof window === 'undefined' || window.__betupleMetrikaLoaded) {
        return;
    }
    window.__betupleMetrikaLoaded = true;

    (function (m, e, t, r, i, k, a) {
        m[i] = m[i] || function () { (m[i].a = m[i].a || []).push(arguments); };
        m[i].l = 1 * new Date();
        for (let j = 0; j < document.scripts.length; j++) {
            if (document.scripts[j].src === r) { return; }
        }
        k = e.createElement(t);
        a = e.getElementsByTagName(t)[0];
        k.async = 1;
        k.src = r;
        a.parentNode.insertBefore(k, a);
    })(window, document, 'script', `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`, 'ym');

    window.ym(METRIKA_ID, 'init', {
        ssr: true,
        webvisor: true,
        clickmap: true,
        ecommerce: 'dataLayer',
        referrer: document.referrer,
        url: location.href,
        accurateTrackBounce: true,
        trackLinks: true,
    });
}
